var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('Title',[_vm._v("API documentation")]),_c('p',[_vm._v(" API base URL: "),_c('b',{staticClass:"has-text-primary"},[_vm._v(_vm._s(_vm.getUrl()))]),_vm._v(". ")]),_c('Article',{attrs:{"title":"Start here"}},[_c('p',[_vm._v("Start with adding a key by clicking on \"Add key\".")]),_c('section',{staticClass:"box"},[_c('ApiKeys')],1),_c('p',[_vm._v(" Use the key for authentication, in the request header. The header name is "),_c('b',{staticClass:"has-text-primary"},[_vm._v("x-api-key")]),_vm._v(". ")]),_c('p',[_vm._v(" It's easier to use "),_c('a',{attrs:{"href":"https://www.postman.com/downloads/","target":"_blank"}},[_vm._v("Postman")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://insomnia.rest/download"}},[_vm._v("Insomnia")]),_vm._v(" when trying out more advanced requests. ")])]),_c('Article',{attrs:{"title":"GET: /sources"}},[_c('p',[_vm._v("Returning all sources/repos. Includes repos shared with you.")]),_c('p',[_vm._v("Example response:")]),_c('pre',{staticClass:"notification is-info is-light"},[_vm._v(_vm._s(JSON.stringify(
            [
              {
                shared: null,
                uid: "000000-0000-4edb-00000-000000000",
                css: "black",
                external: false,
                name: "My repo",
                description: "Private feed",
                permission: 32,
                version: 2,
                url: "",
                key: "longkey",
              },
              {
                shared: null,
                uid: "2f0d2190-e5ee-431c-854a-f73caf4731dc",
                css: "blue darken-1",
                external: true,
                name: "Chocolatey",
                description: "Community feed",
                permission: 32,
                version: null,
                url: "https://chocolatey.org/api/v2/",
                key: "",
              } ],
            undefined,
            2
          )))])]),_c('Article',{attrs:{"title":"GET: /domains"}},[_c('p',[_vm._v("Returning all domains. Includes domains shared with you.")]),_c('p',[_vm._v("Example response:")]),_c('pre',{staticClass:"notification is-info is-light"},[_vm._v(_vm._s(JSON.stringify(
            [
              {
                shared: null,
                uid: "c34d45cc-1873-4793-9cdb-427bc0587a50",
                description: "",
                permission: null,
                friendlyName: "Company co.",
                key: "averylongkey",
                sharedWithOthers: false,
              } ],
            undefined,
            2
          )))])]),_c('Article',{attrs:{"title":"GET: /domains/:domainUID/groups"}},[_c('p',[_vm._v(" Returning all groups. Includes groups shared with you. \"domainUID\" is the uid of a domain. ")]),_c('p',[_vm._v("Full path example:")]),_c('pre',[_vm._v("/domains/c34d45cc-1873-4793-9cdb-427bc0587a50/groups")]),_c('p',[_vm._v("Example response:")]),_c('pre',{staticClass:"notification is-info is-light"},[_vm._v(_vm._s(JSON.stringify(
            [
              {
                id: 183959,
                name: "Office",
                uid: "6cba6338-3250-4859-a1ae-7ac042f4e503",
                css: "cyan-text lighten-1",
              },
              {
                id: 184774,
                name: "General applications",
                uid: "45067282-423b-4d03-8ba3-0c5d6c68800e",
                css: "green-text lighten-1",
              } ],
            undefined,
            2
          )))])]),_c('Article',{attrs:{"title":"GET: /domains/:domainUID/groups-computers"}},[_c('p',[_vm._v(" Returning all groups and all computers per group. \"domainUID\" is the uid of a domain. ")]),_c('p',[_vm._v("Full path example:")]),_c('pre',[_vm._v("/domains/c34d45cc-1873-4793-9cdb-427bc0587a50/groups-computers")]),_c('p',[_vm._v("Example response:")]),_c('pre',{staticClass:"notification is-info is-light"},[_vm._v(_vm._s(JSON.stringify(
            [
              {
                group: {
                  id: 183959,
                  name: "Office",
                  uid: "6cba6338-3250-4859-a1ae-7ac042f4e523",
                  css: "cyan-text lighten-1",
                },
                computers: [
                  {
                    systemInfo: {
                      macAddresses: ["5CEB42076001"],
                    },
                    uid: "781a8fe6-d7fc-22f9-494e-e44b3e4ed001",
                    onlineChanged: "1596462979970",
                    name: "XPS-DATOR",
                    online: false,
                    clientVersion: "0.10.2.0",
                    friendlyName: "Jonas computer",
                    inventorying: false,
                  } ],
              } ],
            undefined,
            2
          )))])]),_c('Article',{attrs:{"title":"GET: /domains/:domainUID/computers"}},[_c('p',[_vm._v(" Returning all computers in a domain. \"domainUID\" is the uid of a domain. ")]),_c('p',[_vm._v("Full path example:")]),_c('pre',[_vm._v("/domains/c34d45cc-1873-4793-9cdb-427bc0587a50/computers")]),_c('p',[_vm._v("Example response:")]),_c('pre',{staticClass:"notification is-info is-light"},[_vm._v(_vm._s(JSON.stringify(
            [
              {
                systemInfo: {
                  macAddresses: ["5CEB42076001"],
                },
                uid: "781a8fe6-d7fc-22f9-494e-e44b3e4ed001",
                onlineChanged: "1596462979970",
                name: "XPS-DATOR",
                online: false,
                clientVersion: "0.10.2.0",
                friendlyName: "Jonas computer",
                inventorying: false,
              } ],
            undefined,
            2
          )))])]),_c('Article',{attrs:{"title":"POST: /domains/:domainUID/package"}},[_c('p',[_vm._v(" Install/uninstall package. These request mirrors the behavior of the website. ")]),_c('p',[_vm._v("Full path example:")]),_c('pre',[_vm._v("/domains/c34d45cc-1873-4793-9cdb-427bc0587a50/package")]),_c('section',{staticClass:"content"},[_c('ul',[_c('li',[_vm._v(" Success status code: "),_c('b',{staticClass:"has-text-success"},[_vm._v("202")])]),_c('li',[_vm._v(" Error status code: "),_c('b',{staticClass:"has-text-danger"},[_vm._v("400")])])])]),_c('p',[_vm._v("Parameters explained:")]),_c('section',{staticClass:"content"},[_c('ul',[_c('li',[_c('span',{staticClass:"tag is-info smaller"},[_vm._v("Targets computers")]),_vm._v(" computerUIDs: String array with computer UIDs. UIDs can be found in "),_c('i',[_vm._v("/domains/:domainUID/computers")])]),_c('li',[_c('span',{staticClass:"tag is-info smaller"},[_vm._v("Targets a group")]),_vm._v(" groupUID: String. UID of a group found in "),_c('i',[_vm._v("/domains/:domainUID/groups")])]),_c('li',[_vm._v(" package: Object "),_c('ul',[_c('li',[_vm._v(" id: String. Package id, same as when using choco locally ")]),_c('li',[_vm._v(" version: String. Package version, same as when using choco locally ")]),_c('li',[_vm._v(" command: String. Either install, uninstall, or upgrade ")]),_c('li',[_vm._v(" sourceUID: String. UID of a source found in "),_c('i',[_vm._v("/sources")])])])]),_c('li',[_c('span',{staticClass:"tag is-info"},[_vm._v("Optional")]),_c('span',{staticClass:"ml-2 tag is-info"},[_vm._v("Only for groups")]),_vm._v(" schedule: Object "),_c('ul',[_c('li',[_vm._v("startDate: String. "),_c('code',[_vm._v("{year} {month} {date}")])]),_c('li',[_vm._v("endDate: String. "),_c('code',[_vm._v("{year} {month} {date}")])]),_c('li',[_vm._v("startTime: String. "),_c('code',[_vm._v("{hour}:{minute}")])]),_c('li',[_vm._v("endTime: String. "),_c('code',[_vm._v("{hour}:{minute}")])]),_c('li',[_vm._v(" repeatWeekDays: String. "),_c('code',[_vm._v("{dayofweek}|{dayofweek}|{dayofweek}")]),_vm._v(". 1 = monday, 7 = sunday. ")]),_c('li',[_vm._v(" autoUpgrade: Boolean. Auto upgrade packages inside the scope of the schedule. ")])])])])]),_c('p',[_vm._v("Request body example (targeting computers):")]),_c('pre',{staticClass:"notification is-info is-light"},[_vm._v(_vm._s(JSON.stringify(
            {
              computerUIDs: ["781a8fe6-d7fc-22f9-494e-e44b3e4ed001"],
              package: {
                id: "notepad3.install",
                version: "6.23.203.2",
                command: "install",
                sourceUID: "000000-0000-4edb-00000-000000000",
              },
            },
            undefined,
            2
          )))]),_c('p',[_vm._v(" Request body example (targeting a group). Schedule is optional. ")]),_c('pre',{staticClass:"notification is-info is-light"},[_vm._v(_vm._s(JSON.stringify(
            {
              groupUID: ["6cba6338-3250-4859-a1ae-7ac042f4e503"],
              package: {
                id: "notepad3.install",
                version: "6.23.203.2",
                command: "install",
                sourceUID: "000000-0000-4edb-00000-000000000",
              },
              schedule: {
                startDate: "2023 07 08",
                endDate: "2030 07 08",
                startTime: "14:00",
                endTime: "12:00",
                repeatWeekDays: "1|2|7",
                autoUpgrade: false,
              },
            },
            undefined,
            2
          )))]),_c('p',[_vm._v("Error response example:")]),_c('pre',[_vm._v(_vm._s(JSON.stringify(
            {
              message:
                "The package was not found in repo with param sourceUID: 2f0d2190-e5ee-431c-854a-f73caf4731dc",
            },
            undefined,
            2
          )))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }